/*
 * @Author: tianzhi 
 * @Date: 2019-08-08 14:53:13 
 * @Last Modified by: zhongxue
 * @Last Modified time: 2020-12-16 14:20:56
 */
import * as React from 'react';
import { Popover } from 'antd';
import $ from 'jquery';
import './style.less';

const noDataUrl = require('@/statics/img/qr_code.jpg');

class SideLayer extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      QQMouseOver: false,
      goTopIconShow: false
    };
  }

  componentDidMount() {
    this.getFindMarketFn();

    window.onscroll = () => {
      var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;

      if (scrollTop > 0) {
        this.setState({
          goTopIconShow: true
        });
      } else {
        this.setState({
          goTopIconShow: false
        });
      }
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.sideLayerInfo !== this.props.sideLayerInfo) {
      this.getFindMarketFn(nextProps.sideLayerInfo);
    }
  }

  getFindMarketFn = sideLayerInfo => {
    let jsonData = sideLayerInfo || this.props.sideLayerInfo;
    if (!jsonData) return;
    this.markQQFn(jsonData);

    if (jsonData.companyId == "3125" || jsonData.schoolHide == "1") {
      $("#headContents>.select-place-wrap,.schoolList,#J_wxBranch").addClass("none");
    }

    if (jsonData.leyuFlag == "1") {
      $(".layer-list").find(".leyu").hide();
      $(".layer-list").find(".leyu").data("data", jsonData);
      $.getScript("http://lead.soperson.com/10041370/10093275.js", function () {
        $.getScript("http://static.doyoo.net/110402/looyu.js?141104", function () {
          var lytimer = setInterval(function () {
            if (typeof doyoo != 'undefined' && doyoo != null && doyoo.util != null && typeof doyoo.util != 'undefined') {
              $(".layer-list").find(".leyu").show();
              $(".layer-list").find(".leyu").bind("click", function () {
                if (typeof jsonData.leyuNo != 'undefined' && jsonData.leyuNo != "") {
                  $(".layer-list").find(".leyu").bind("click", function () {
                    doyoo.util.openChat(jsonData.leyuNo);
                  });
                } else {
                  $(".layer-list").find(".leyu").bind("click", function () {
                    doyoo.util.openChat('');
                  });
                }
              });
              clearInterval(lytimer);
            }
          }, 1000);
        });
      });
    } else {
      if (jsonData.bdsqFlag == "1") {
        var link = $(".layer-list").find("a.leyu");

        if (jsonData.bdsqType == 0) {
          //不自动弹出
          let timer = setInterval(() => {
            link = $(".layer-list").find("a.leyu");
            $(".layer-list").find("a.leyu");

            if (link.length > 0) {
              clearInterval(timer);
              link.attr("href", "http://p.qiao.baidu.com/cps/chat?" + jsonData.bdsqJsUrl);
            }
          }, 1000);
        } else if (jsonData.bdsqType == 1 && !/\/classModule\/video\/\d+\/\d+\/\d+\/\d+\/\d+/.test(location.href) && !/\/classModule\/toLiveroom\?/.test(location.href)) {
          //自动弹出
          //jquery不生效，原生操作
          var head = document.getElementsByTagName('head')[0];
          var script = document.createElement('script');
          script.type = 'text/javascript';

          var _bdhmProtocol = "http:" == document.location.protocol ? " http://" : " http://";

          script.src = _bdhmProtocol + "hm.baidu.com/h.js?" + jsonData.bdsqJsUrl;
          head.appendChild(script); //绑定事件

          link.off().on("click", function () {
            $("ins#nb_icon_wrap").click();
          });
        }
      }
    }

    if (jsonData.otherImFlag == "1" && !document.getElementById('otherImgId') && !/\/classModule\/video\/\d+\/\d+\/\d+\/\d+\/\d+/.test(location.href) && !/\/classModule\/toLiveroom\?/.test(location.href)) {
      let otherImgRender = `<div id="otherImgId">${jsonData.otherImJs}</div>`;

      if (window.location.hash.indexOf('/join/login') !== -1) {
        otherImgRender = `<div id="otherImgId" style="width:100%;position:fixed;bottom:0">${jsonData.otherImJs}</div>`;
      }

      $("body").append(otherImgRender || '');
    }

    $(".side-bar.side-bar-fixed").show();
  }; // handleQQMouseClick = () => {
  //   const { qqType, qqNum, personalqqNum  } = this.props.sideLayerInfo;
  //   let qq = qqType == 'MARKET_QQ_MARKET' ? qqNum : personalqqNum;
  //   window.open(`http://wpa.qq.com/msgrd?v=3&uin=${qq}&site=qq&menu=yes`, '_blank')
  //   // window.open(`http://wpa.qq.com/msgrd?v=3&uin=${qq}&site=qq&menu=yes`);
  // }

  handleGoBackTop = () => {
    (function smoothscroll() {
      var currentScroll = document.documentElement.scrollTop || document.body.scrollTop;

      if (currentScroll > 0) {
        window.requestAnimationFrame(smoothscroll);
        window.scrollTo(0, currentScroll - currentScroll / 5);
      }
    })();
  };
  goToQQ = () => {
    const {
      qqType,
      qqNum,
      personalqqNum,
      qqKey
    } = this.props.sideLayerInfo;
    if (qqType == 'MARKET_QQ_MARKET') return false;
    window.open(`http://wpa.qq.com/msgrd?v=3&uin=${personalqqNum}&site=qq&menu=yes`, '_blank');
  };
  markQQFn = sideLayerInfo => {
    // 营销qq
    const {
      qqType,
      qqNum,
      personalqqNum,
      qqKey
    } = sideLayerInfo;

    if (qqType == 'MARKET_QQ_MARKET') {
      BizQQWPA.addCustom({
        aty: '0',
        //指定工号类型,0-自动分流，1-指定工号，2-指定分组
        nameAccount: qqNum,
        //营销 QQ 号码
        selector: 'onlineService' //WPA 被放置的元素

      });
    }
  };
  getIcon = type => {
    let obj = {
      LINEQQ: 'iconQQ1',
      LINEWX: 'iconweixin1',
      LINEWB: 'iconweibo1',
      LINEKF: 'icondianhua',
      FACEQQ: 'iconQQ2',
      FACEWX: 'iconweixin2',
      FACEWB: 'iconweibo2',
      FACEKF: 'iconkefu-51'
    };
    return obj[type] || '';
  };

  render() {
    const {
      state
    } = this;
    const sideLayerInfo = this.props.sideLayerInfo || {}; // const TYPE = sideLayerInfo.tempFlag != 1 ? 1 : (sideLayerInfo.tempType || 1);

    const TYPE = sideLayerInfo.tempType || 1;
    const ICONTYPE = TYPE == 1 ? "LINE" : "FACE"; //微信

    const weixinContent = <div data-inspector-line="172" data-inspector-column="6" data-inspector-relative-path="src\\containers\\Layout\\SideLayer\\index.jsx" className="side-layer-popover">
        {sideLayerInfo.weixinFlag == 1 && <React.Fragment>
          <img data-inspector-line="174" data-inspector-column="10" data-inspector-relative-path="src\\containers\\Layout\\SideLayer\\index.jsx" src={sideLayerInfo.weixinPic} alt="" />
          <h3 data-inspector-line="175" data-inspector-column="10" data-inspector-relative-path="src\\containers\\Layout\\SideLayer\\index.jsx">关注微信公众号</h3>
        </React.Fragment> || null}
        {sideLayerInfo.personalWeixinFlag == 1 && <React.Fragment>
          <img data-inspector-line="178" data-inspector-column="10" data-inspector-relative-path="src\\containers\\Layout\\SideLayer\\index.jsx" src={sideLayerInfo.personalWeixinPic} alt="" />
          <h3 data-inspector-line="179" data-inspector-column="10" data-inspector-relative-path="src\\containers\\Layout\\SideLayer\\index.jsx">扫一扫，咨询微信</h3>
        </React.Fragment> || null}
      </div>; //微博

    const weiboContent = <div data-inspector-line="185" data-inspector-column="6" data-inspector-relative-path="src\\containers\\Layout\\SideLayer\\index.jsx" className="side-layer-popover">
        <img data-inspector-line="186" data-inspector-column="8" data-inspector-relative-path="src\\containers\\Layout\\SideLayer\\index.jsx" src={sideLayerInfo.weiboPic} alt="" />
        <h3 data-inspector-line="187" data-inspector-column="8" data-inspector-relative-path="src\\containers\\Layout\\SideLayer\\index.jsx">关注微博账号</h3>
      </div>; //联系电话

    const phoneContent = <div data-inspector-line="192" data-inspector-column="6" data-inspector-relative-path="src\\containers\\Layout\\SideLayer\\index.jsx" className="side-layer-popover phone">
        <div data-inspector-line="193" data-inspector-column="8" data-inspector-relative-path="src\\containers\\Layout\\SideLayer\\index.jsx" className="phone-content">
          <p data-inspector-line="194" data-inspector-column="10" data-inspector-relative-path="src\\containers\\Layout\\SideLayer\\index.jsx">工作时间：</p>
          <span data-inspector-line="195" data-inspector-column="10" data-inspector-relative-path="src\\containers\\Layout\\SideLayer\\index.jsx">{sideLayerInfo.serviceTime}</span>
        </div>
        <div data-inspector-line="197" data-inspector-column="8" data-inspector-relative-path="src\\containers\\Layout\\SideLayer\\index.jsx" className="phone-content">
          <p data-inspector-line="198" data-inspector-column="10" data-inspector-relative-path="src\\containers\\Layout\\SideLayer\\index.jsx">联系电话：</p>
          <div data-inspector-line="199" data-inspector-column="10" data-inspector-relative-path="src\\containers\\Layout\\SideLayer\\index.jsx">
            <span data-inspector-line="200" data-inspector-column="12" data-inspector-relative-path="src\\containers\\Layout\\SideLayer\\index.jsx">{sideLayerInfo.servicePhone}</span>
            <br data-inspector-line="201" data-inspector-column="12" data-inspector-relative-path="src\\containers\\Layout\\SideLayer\\index.jsx" />
            {sideLayerInfo.servicePhone1 && <span data-inspector-line="202" data-inspector-column="44" data-inspector-relative-path="src\\containers\\Layout\\SideLayer\\index.jsx">{sideLayerInfo.servicePhone1}</span> || null}
            <br data-inspector-line="203" data-inspector-column="12" data-inspector-relative-path="src\\containers\\Layout\\SideLayer\\index.jsx" />
            {sideLayerInfo.servicePhone2 && <span data-inspector-line="204" data-inspector-column="44" data-inspector-relative-path="src\\containers\\Layout\\SideLayer\\index.jsx">{sideLayerInfo.servicePhone2}</span> || null}
          </div>
        </div>
      </div>;

    const textRender = (text1, text2) => {
      if (TYPE == 4) return <p data-inspector-line="211" data-inspector-column="28" data-inspector-relative-path="src\\containers\\Layout\\SideLayer\\index.jsx">{text1}<br data-inspector-line="211" data-inspector-column="38" data-inspector-relative-path="src\\containers\\Layout\\SideLayer\\index.jsx" />{text2}</p>;
      return null;
    };

    return <div data-inspector-line="216" data-inspector-column="6" data-inspector-relative-path="src\\containers\\Layout\\SideLayer\\index.jsx" className="layout-side-layer">
        <div data-inspector-line="217" data-inspector-column="8" data-inspector-relative-path="src\\containers\\Layout\\SideLayer\\index.jsx" className={`side-layer-inner layer-inner_${TYPE}`}>
          {//微信
        (sideLayerInfo.weixinFlag == 1 || sideLayerInfo.personalWeixinFlag == 1) && <Popover data-inspector-line="221" data-inspector-column="12" data-inspector-relative-path="src\\containers\\Layout\\SideLayer\\index.jsx" placement="leftTop" content={weixinContent} trigger="hover">
              <div data-inspector-line="222" data-inspector-column="14" data-inspector-relative-path="src\\containers\\Layout\\SideLayer\\index.jsx" className="layer-list ">
              <span data-inspector-line="223" data-inspector-column="14" data-inspector-relative-path="src\\containers\\Layout\\SideLayer\\index.jsx"><i data-inspector-line="223" data-inspector-column="20" data-inspector-relative-path="src\\containers\\Layout\\SideLayer\\index.jsx" className={`iconfont ${this.getIcon(ICONTYPE + 'WX')}`}></i>{textRender('微信', '公众号')}</span>
              </div>
            </Popover>}

          {//QQ
        sideLayerInfo.qqFlag == 1 && <div data-inspector-line="231" data-inspector-column="12" data-inspector-relative-path="src\\containers\\Layout\\SideLayer\\index.jsx" className="layer-list" id='onlineService' onClick={this.goToQQ}>
                <span data-inspector-line="232" data-inspector-column="16" data-inspector-relative-path="src\\containers\\Layout\\SideLayer\\index.jsx">
                  <i data-inspector-line="233" data-inspector-column="18" data-inspector-relative-path="src\\containers\\Layout\\SideLayer\\index.jsx" className={`iconfont ${this.getIcon(ICONTYPE + 'QQ')}`}></i>
                  {textRender('在线', 'QQ')}
                </span>
              {
            /* {this.state.QQMouseOver ?
             <a className="online " href={`http://wpa.qq.com/msgrd?v=3&amp;uin=${sideLayerInfo.qqNum}&amp;site=qq&amp;menu=yes`} title="在线QQ" target="_blank">在线QQ</a> :
            } */
          }
            </div>}

          {//微博
        sideLayerInfo.weiboFlag == 1 && <Popover data-inspector-line="245" data-inspector-column="12" data-inspector-relative-path="src\\containers\\Layout\\SideLayer\\index.jsx" placement="leftTop" content={weiboContent} trigger="hover">
              <div data-inspector-line="246" data-inspector-column="14" data-inspector-relative-path="src\\containers\\Layout\\SideLayer\\index.jsx" className="layer-list ">
                <a data-inspector-line="247" data-inspector-column="16" data-inspector-relative-path="src\\containers\\Layout\\SideLayer\\index.jsx" href={sideLayerInfo.weiboUrl} target="_blank" title="微博账号"><i data-inspector-line="247" data-inspector-column="78" data-inspector-relative-path="src\\containers\\Layout\\SideLayer\\index.jsx" className={`iconfont ${this.getIcon(ICONTYPE + 'WB')}`}></i>{textRender('微博', '账号')}</a>
              </div>
            </Popover>}

          {// 客服咨询
        sideLayerInfo.bdsqType == 0 && sideLayerInfo.bdsqFlag == "1" && <div data-inspector-line="255" data-inspector-column="14" data-inspector-relative-path="src\\containers\\Layout\\SideLayer\\index.jsx" className="layer-list ">
                <a data-inspector-line="256" data-inspector-column="16" data-inspector-relative-path="src\\containers\\Layout\\SideLayer\\index.jsx" className='leyu' href="javascript:void(0)" target="_blank" title="在线客服"><i data-inspector-line="256" data-inspector-column="91" data-inspector-relative-path="src\\containers\\Layout\\SideLayer\\index.jsx" className="iconfont iconzixun"></i><p data-inspector-line="256" data-inspector-column="129" data-inspector-relative-path="src\\containers\\Layout\\SideLayer\\index.jsx">在线<br data-inspector-line="256" data-inspector-column="134" data-inspector-relative-path="src\\containers\\Layout\\SideLayer\\index.jsx" />咨询</p></a>
              </div>}

          {//咨询
        sideLayerInfo.serviceFlag == 1 && <Popover data-inspector-line="263" data-inspector-column="12" data-inspector-relative-path="src\\containers\\Layout\\SideLayer\\index.jsx" placement="leftTop" content={phoneContent} trigger="hover">
              <div data-inspector-line="264" data-inspector-column="14" data-inspector-relative-path="src\\containers\\Layout\\SideLayer\\index.jsx" className="layer-list ">
                <span data-inspector-line="265" data-inspector-column="16" data-inspector-relative-path="src\\containers\\Layout\\SideLayer\\index.jsx">
                  <i data-inspector-line="266" data-inspector-column="18" data-inspector-relative-path="src\\containers\\Layout\\SideLayer\\index.jsx" className={`iconfont ${this.getIcon(ICONTYPE + 'KF')}`}></i>
                  {textRender('在线', '咨询')}
                </span>
              </div>
            </Popover>}
          
          {//回到顶部
        this.state.goTopIconShow && <div data-inspector-line="276" data-inspector-column="12" data-inspector-relative-path="src\\containers\\Layout\\SideLayer\\index.jsx" className="layer-list " onClick={this.handleGoBackTop}>
              <span data-inspector-line="277" data-inspector-column="14" data-inspector-relative-path="src\\containers\\Layout\\SideLayer\\index.jsx">
                <i data-inspector-line="278" data-inspector-column="16" data-inspector-relative-path="src\\containers\\Layout\\SideLayer\\index.jsx" className="iconfont iconfanhuidingbu"></i>
                {textRender('回到', '顶部')}
              </span>
            </div>}
        </div>
      </div>;
  }

}

export default SideLayer;